"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeHms = exports.formatTime = exports.secondsToHoursMinsSecsStr = exports.secondsToHoursMinsSecs = exports.getTsFormats = exports.getTimestampAlt = exports.getTimestamp = exports.getTsDistanceInDays = exports.getTsDistance = exports.parseDateString = exports.abbreviateNumber = void 0;
const differenceInDays_1 = __importDefault(require("date-fns/differenceInDays"));
const differenceInYears_1 = __importDefault(require("date-fns/differenceInYears"));
const format_1 = __importDefault(require("date-fns/format"));
const formatDistanceStrict_1 = __importDefault(require("date-fns/formatDistanceStrict"));
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
/**
 * Abbreviates numbers to at most 3 digits (2 integer + 1 fractional, or 3
 * integer & no fractional) and attaches a K, M, or B unit to signify the
 * magnitude.
 *
 * FIXME: Because it uses toFixed(), the number is rounded up, which might be
 * less than ideal for certain display purposes.
 */
function abbreviateNumber(n) {
    const symbol = ['', 'K', 'M', 'B'];
    if (n === 0) {
        return '0';
    }
    const parity = n < 0 ? '-' : '';
    if (n < 0) {
        n *= -1;
    }
    const tier = Math.floor(Math.log10(n) / 3);
    if (tier === 0) {
        return parity + n.toString();
    }
    const suffix = symbol[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = n / scale;
    if (scaled >= 100) {
        return parity + scaled.toFixed(0) + suffix;
    }
    else {
        return parity + scaled.toFixed(1) + suffix;
    }
}
exports.abbreviateNumber = abbreviateNumber;
function parseDateString(ts) {
    return ts instanceof Date ? ts : (0, parseISO_1.default)(ts);
}
exports.parseDateString = parseDateString;
/**
 * Returns the distance from now if within one day. Otherwise, returns the
 * absolute date: [Year if > 1 year old] Month Day
 *
 * @param ts If string, an ISO-8601 timestamp. Otherwise, a JS Date object.
 * @param now The current datetime to compare to. Useful to set when testing.
 *   Otherwise, if unset, uses the current datetime.
 */
function getTsDistance(ts, now) {
    const fromNow = now !== null && now !== void 0 ? now : new Date();
    const parsedTs = ts instanceof Date ? ts : (0, parseISO_1.default)(ts);
    if ((0, differenceInDays_1.default)(fromNow, parsedTs) > 0) {
        if ((0, differenceInYears_1.default)(fromNow, parsedTs) > 0) {
            return (0, format_1.default)(parsedTs, 'yyyy MMM d');
        }
        else {
            return (0, format_1.default)(parsedTs, 'MMM d');
        }
    }
    else {
        const [val, unit] = (0, formatDistanceStrict_1.default)(parsedTs, fromNow).split(' ');
        return val + unit[0];
    }
}
exports.getTsDistance = getTsDistance;
function getTsDistanceInDays(ts, now) {
    const fromNow = now !== null && now !== void 0 ? now : new Date();
    const parsedTs = ts instanceof Date ? ts : (0, parseISO_1.default)(ts);
    const days = (0, differenceInDays_1.default)(fromNow, parsedTs);
    if (days === 0) {
        return 'today';
    }
    else {
        return `${days} days ago`;
    }
}
exports.getTsDistanceInDays = getTsDistanceInDays;
function getTimestamp(ts) {
    return (0, format_1.default)(ts, 'h:mm aa MMM d, yyyy');
}
exports.getTimestamp = getTimestamp;
function getTimestampAlt(ts) {
    return (0, format_1.default)(ts, 'MMM d, yyyy h:mm aa');
}
exports.getTimestampAlt = getTimestampAlt;
/**
 * Returns pair [ts distance, ts]. Useful for displaying the ts distance and
 * including the full ts on hover.
 *
 * @param ts An ISO-8601 timestamp.
 */
function getTsFormats(ts) {
    const parsedTs = (0, parseISO_1.default)(ts);
    return [getTsDistance(parsedTs), getTimestamp(parsedTs)];
}
exports.getTsFormats = getTsFormats;
/**
 * @returns [hours, minutes, seconds]
 */
function secondsToHoursMinsSecs(seconds) {
    return [Math.floor(seconds / 3600), Math.floor((seconds % 3600) / 60), seconds % 60];
}
exports.secondsToHoursMinsSecs = secondsToHoursMinsSecs;
/**
 * @returns "Xh Ym Zs"
 */
function secondsToHoursMinsSecsStr(seconds) {
    const [hrs, mins, secs] = secondsToHoursMinsSecs(seconds);
    return `${hrs}h ${mins}m ${secs}s`;
}
exports.secondsToHoursMinsSecsStr = secondsToHoursMinsSecsStr;
function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const paddedSeconds = remainingSeconds.toString().padStart(2, '0');
    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${paddedSeconds}`;
    }
    else if (minutes > 0) {
        return `${minutes.toString()}:${paddedSeconds}`;
    }
    else {
        return `:${paddedSeconds}`;
    }
}
exports.formatTime = formatTime;
function formatTimeHms(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    const hoursString = hours > 0 ? `${hours}h` : '';
    const minutesString = minutes > 0 || hours > 0 ? `${minutes}m` : '';
    const secondsString = `${remainingSeconds}s`;
    return `${hoursString}${minutesString}${secondsString}`;
}
exports.formatTimeHms = formatTimeHms;
